module.exports = __webpack_public_path__ + "static/media/blogthumb1.f3813bca.jpg";